import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';

const Settings =() => {
    return(
      <>
     <Breadcrumb />
       <Typography>
        Settings works
        </Typography>
       </>
       );
};
export default Settings;